// containerFillStandard.js — pure model for the Container block's Background
// control, GORDON 2026-09-15 (Container block settings pane standardisation,
// item 3): "Background must use the app standard fill control: Colors / Gradient
// / Patterns / Image tabs, brand swatches, Media Library for image selection, NO
// Opacity slider."
//
// DELIBERATELY A SEPARATE FILE from ./containerBackground.js: that module's
// CONTAINER_FILL_TYPES / CONTAINER_FILL_TYPE_LABEL / ContainerBackgroundControl
// are also reused verbatim by the UNRELATED Title Bar block
// (CodeBlocks/TitleBar/TitleBarSettings.jsx imports
// "../Container/ContainerBackgroundControl" directly, with its own opt-in
// `extraTypes`/`renderExtra` Patterns-tab mechanism AND an Opacity slider on the
// Color tab it relies on). Changing the shared tab list or removing the Opacity
// slider there would silently break Title Bar's Background control. This module
// re-exports the pure, already-correct pieces of containerBackground.js (the
// gradient/image normalisation + resolution, which already understands a
// `{type:"pattern",css}` fill — see its own "ADDITIVE... Opt-in surfaces" note)
// and adds ONLY the new tab list + label set + pattern default that Container's
// OWN standard control (ContainerFillControl.jsx) uses. Container's craft node
// still stores a plain `containerFill` prop of the exact same shape
// containerBackground.js already resolves, so the renderer (Container.jsx) needs
// no changes to paint a pattern fill.
export {
  defaultGradientFill,
  defaultImageFill,
  normalizeContainerFill,
  isStructuredFill,
  fillTypeOf,
  resolveContainerBackground,
} from "./containerBackground";

/**
 * The app-standard fill tab set + order — the SAME as the Accordion block's
 * Title Background (accordionHeaderBackground.js HEADER_FILL_TYPES): Colors ·
 * Gradient · Patterns · Image.
 */
export const STANDARD_FILL_TYPES = ["color", "gradient", "pattern", "image"];

export const STANDARD_FILL_TYPE_LABEL = {
  color: "Colors",
  gradient: "Gradient",
  pattern: "Patterns",
  image: "Image",
};

/** A fresh, empty pattern fill (the picker fills in the finished css). */
export const defaultPatternFill = () => ({ type: "pattern", css: "" });
